
import { property } from 'underscore';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class GreyBoxForm extends Vue {
    @Prop({required: true})
    beforetext!: string;

    @Prop({ required: false, default: '' })
    aftertext!: string;

    @Prop({ required: true })
    text!: string;

    @Prop({ required: true })
    hint!: string;

    @Prop({ required: false, default: '100px' })
    hintindent!: string;

    @Prop({ required: true })
    textwidth!: string;

    @Prop({ required: false, default: '6pt' })
    hintFontSize!: string;

    @Prop({ required: false, default: '11pt' })
    entryFontSize!: string;

    @Prop({ required: false, default: false })
    italicHint!: boolean;

    @Prop({ default: '-20px' })
    marginTop!: string;

    @Prop({ default: '-1px' })
    hintmargintop!: string;
 
}
